export class ContractReturnRequestModel {
    sociedadContrato: string;
    contrato: string;
    serialNumber: string;
    creditNote: number;
    chargeNote: number;

    constructor() {
        this.sociedadContrato = "";
        this.contrato = "";
        this.serialNumber = "";
        this.creditNote = 0;
        this.chargeNote = 0;
    }
}